"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionHeader = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SuggestionHeader_st_css_1 = require("./SuggestionHeader.st.css");
exports.SuggestionHeader = function (_a) {
    var _b = _a.showAllText, showAllText = _b === void 0 ? '{showAllText}' : _b, props = tslib_1.__rest(_a, ["showAllText"]);
    return (React.createElement("div", { className: SuggestionHeader_st_css_1.st(SuggestionHeader_st_css_1.classes.root) },
        React.createElement("div", { className: SuggestionHeader_st_css_1.st(SuggestionHeader_st_css_1.classes.inner) },
            React.createElement("span", { className: SuggestionHeader_st_css_1.st(SuggestionHeader_st_css_1.classes.title) }, props.title),
            React.createElement("a", { href: props.url, "data-hook": "suggestions-show-all", onClick: props.onShowAllClick, className: SuggestionHeader_st_css_1.st(SuggestionHeader_st_css_1.classes.showAllLink) }, showAllText)),
        React.createElement("div", { className: SuggestionHeader_st_css_1.st(SuggestionHeader_st_css_1.classes.divider) })));
};
//# sourceMappingURL=SuggestionHeader.js.map